<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Tỷ giá - phí</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input v-model="configuration.Currency" :decimal="0" label="Tỷ giá" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input v-model="configuration.ExchangeRevenue" :decimal="0" label="Lãi tỷ giá" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.MinFeeBuy" :decimal="0" label="Phí mua tối thiểu" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.MinFeePack" :decimal="1" label="Phí đóng gỗ tối thiểu 1 kiện (¥)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <v-text-field type="number" v-model="configuration.OrderCompleteDate" label="Số ngày tự động hoàn thành đơn" class="input-group--focused"></v-text-field>
                                </v-flex>
                                </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="0" v-model="configuration.Density" label="Tỷ trọng cân nặng" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="0" v-model="configuration.Surcharge" label="Phụ phí" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.EntrustRate" label="Phí uỷ thác (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-switch v-model="configuration.ShowNoteForCustomer" label="Hiển thị thông báo khách hàng" class="input-group--focused"></v-switch>
                    <v-layout row wrap v-if="configuration.ShowNoteForCustomer">
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Thông báo khách hàng</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="showCode = !showCode">
                                <v-icon color="#ffffff">fa fa-code</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <vue-editor v-if="!showCode" v-model="configuration.NoteForCustomer" label="Thông báo khách hàng" class="input-group--focused"></vue-editor>
                                    <v-textarea v-else v-model="configuration.NoteForCustomer" label="Thông báo khách hàng" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
    <div class="page-header-left pa-3 pt-8">
        <h4>Cấu hình phí đóng gỗ/chống sốc</h4>
    </div>
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="configuration.FirstWeigthWood" :decimal="1" label="Phí đóng gỗ cân đầu" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="configuration.NextWeightWood" :decimal="1" label="Phí đóng gỗ cân tiếp theo" class="input-group--focused"></h-currency-input>
                </v-flex>
            </v-layout>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="configuration.FirstWeigthWrap" :decimal="1" label="Phí chống sốc cân đầu" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="configuration.NextWeightWrap" :decimal="1" label="Phí chống sốc cân tiếp theo" class="input-group--focused"></h-currency-input>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data() {
        return {
            showCode: false
        }
    },
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
